import { useEffect, useMemo, useState } from "react";
import { FileType } from "reedy-data/models";
import { useCollectionData } from "react-firebase-hooks/firestore";
import {
  getCountFromServer,
  orderBy,
  query,
  where,
  limit,
} from "firebase/firestore";
import { getPipelineReportCollection } from "integrations/firebase/collections";
import { usePagination } from "./usePagination";

export const usePipelineReports = ({
  mode,
  organisationId,
}: {
  mode: FileType;
  organisationId: string;
}) => {
  const [itemsCount, setItemsCount] = useState(0);
  const { page, pageSize, setPage } = usePagination();

  const baseQuery = useMemo(
    () =>
      query(
        getPipelineReportCollection(),
        where("organisation.id", "==", organisationId),
        where("mode", "==", mode),
        orderBy("createdAt", "desc"),
      ),
    [organisationId, mode],
  );

  const from = (page - 1) * pageSize;
  const to = from + pageSize;

  const [reports = [], loading] = useCollectionData(
    query(baseQuery, limit(to)),
  );

  useEffect(() => {
    const refreshCount = async () => {
      const snapshot = await getCountFromServer(baseQuery);
      const { count } = snapshot.data();
      setItemsCount(count);
    };

    refreshCount();
  }, [baseQuery]);

  return {
    loading,
    reports: reports.slice(from, to),
    itemsCount,
    setPage,
  };
};
